import { BooleanLike } from "~/api/_common/types"
import { RecruitmentStatus } from "~/consts/index"

import { Company, CreateCompanyArgs } from "./Company"
import { ShortInternshipSchedule, CreatedShortInternshipScheduleArgs } from "./ShortInternshipSchdule"

export interface createShortInternshipArgs {
  id: number
  title: string
  job_type: string
  content: string
  qualification: string
  reward: string
  selection_flow: string
  expected_recruitment_numbers: string
  has_external_application: BooleanLike
  application_url?: string
  thumbnail_img_url: string
  status: keyof typeof RecruitmentStatus
  url: string
  short_internship_target_grad_years: {
    grad_year: number
  }[]
  // created_at: string
  short_internship_schedules?: CreatedShortInternshipScheduleArgs[]
  company: CreateCompanyArgs
}

export class ShortInternship {
  id: number
  title: string
  jobType: string
  content: string
  qualification: string
  reward: string
  selectionFlow: string
  expectedRecruitmentNumbers: string
  isExternalApplication: boolean
  applicationUrl?: string
  thumbnailImgUrl: string
  status: keyof typeof RecruitmentStatus
  url: string
  targetGradYears: number[]
  createdAt?: string
  schedules?: ShortInternshipSchedule[]
  company: Company

  constructor(args: createShortInternshipArgs) {
    this.id = args.id
    this.title = args.title
    this.jobType = args.job_type
    this.content = args.content
    this.qualification = args.qualification
    this.reward = args.reward
    this.selectionFlow = args.selection_flow
    this.expectedRecruitmentNumbers = args.expected_recruitment_numbers
    this.isExternalApplication = Boolean(args.has_external_application)
    this.applicationUrl = args.application_url
    this.thumbnailImgUrl = args.thumbnail_img_url
    this.status = args.status
    this.url = args.url || ""
    this.targetGradYears =
      args.short_internship_target_grad_years &&
      args.short_internship_target_grad_years.map((grad_year) => {
        return grad_year.grad_year - 2000
      })
    // this.createdAt = args.created_at
    this.schedules =
      args.short_internship_schedules &&
      args.short_internship_schedules.map((schedule) => new ShortInternshipSchedule(schedule))
    this.company = new Company(args.company)
  }

  get sortedSchedules(): ShortInternshipSchedule[] | undefined {
    if (this.schedules) {
      const beforeDeadlineSchedules = this.schedules.filter((schedule) => schedule.entryDeadline !== "募集終了")
      const afterDeadlineSchedules = this.schedules.filter((schedule) => schedule.entryDeadline === "募集終了")

      return beforeDeadlineSchedules.concat(afterDeadlineSchedules)
    }
  }
}
